import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneCoupon from './submodules/clone';
import CouponConversions from './submodules/conversions';
import CreateCoupon from './submodules/create';
import ListCoupon from './submodules/list';
import EditCoupon from './submodules/edit';

const CouponDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.coupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].getCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.coupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].createCoupon]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.coupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].createCoupon]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.coupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].getCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/payoutDetails`}
				component={CouponConversions}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.coupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].updateCoupon]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditCoupon}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default CouponDashboard;
